import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';

import { modifierList } from './props-list';

const DEFAULT_CLASSNAMES = '';

const Icon = ({ modifiers, classNames = DEFAULT_CLASSNAMES, svg, ...props }) => {
  const Svg = svg;
  let cn = getClassNames('icon', modifiers);
  if (classNames) {
    cn += ` ${classNames}`;
  }

  return (
    <i className={cn} {...props}>
      <Svg />
    </i>
  );
};

Icon.propTypes = {
  svg: PropTypes.func.isRequired,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  classNames: PropTypes.string,
};

export default Icon;
